export enum Payment {
  PAYMENT_PAGE_PAYMENT_NOT_SELECTED_ERROR_MESSAGE = 'payment_page_payment_not_selected_error_message',
}
